import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getUser } from '../API';

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    getUser().then((response) => {
      setIsLoggedIn(response != null && response.profileid);
    });
  }, [location.pathname]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    const API_URL = window.location.hostname === 'localhost' ? 'http://localhost:8000' : '';
    window.open(`${API_URL}/auth/logout`, '_self');
  };

  const navLinkClass = (path) =>
    `site-nav-link${location.pathname === path ? ' site-nav-link-active' : ''}`;

  return (
    <header className="site-header">
      <div className="container site-header-inner">
        <div className="site-header-top">
          <Link to="/" className="site-brand">
            <span className="site-brand-icon" aria-hidden="true">
              <i className="fas fa-microscope"></i>
            </span>
            <span className="site-brand-text">Medcodes</span>
          </Link>

          {isLoggedIn && (
            <button
              className="site-nav-toggle"
              type="button"
              aria-controls="siteNav"
              aria-expanded={menuOpen}
              aria-label="Menu"
              onClick={() => setMenuOpen((open) => !open)}
            >
              <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
            </button>
          )}
        </div>

        {isLoggedIn && (
          <nav
            className={`site-nav${menuOpen ? ' site-nav-open' : ''}`}
            id="siteNav"
            aria-label="Navigation principale"
          >
            <div className="site-nav-links">
              <Link to="/transaction" className={navLinkClass('/transaction')}>
                Transaction
              </Link>
              <Link to="/historique" className={navLinkClass('/historique')}>
                Historique
              </Link>
              <Link to="/dashboard" className={navLinkClass('/dashboard')}>
                Tableau de bord
              </Link>
            </div>
            <button type="button" className="site-nav-logout" onClick={handleLogout}>
              Déconnexion
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
